import * as Scrivito from "scrivito"

export const HeroWidget = Scrivito.provideWidgetClass("HeroWidget", {
  attributes: {
    headline: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    text: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    image: ["reference", { only: "Image" }],
    imageWidgets: [
      "widgetlist",
      { only: ["ImageWidget", "LightDarkImageWidget"], maximum: 1 }
    ],
    buttons: ["widgetlist", { only: ["ButtonWidget", "LoginButtonWidget"] }],
    version: ["enum", { values: ["v1", "v2"] }]
  }
})
